import { instanceApi } from '../../../services';

export const getPartnerPartnerships = (): Promise<any> =>
  instanceApi.get(
    'api/Dashboard/GetPartnerPartnerships?showExpired=true&OnlyIb=true',
  );

export const getClientShortCodes = (
  partnershipId: number,
): Promise<any> =>
  instanceApi.get(
    `api/partners/partnership/links/${partnershipId}/client/short-codes`,
  );

export const getLinkStatisticsReport = (
  fromDate: string,
  toDate: string,
  periodType: number,
  partnershipCode?: string,
  linkCode?: string,
): Promise<any> => {
  let url = `api/partners/reports/LinkStatistics/PH?StartDate=${fromDate}&EndDate=${toDate}&PeriodType=${periodType}`;

  if (partnershipCode) {
    url += `&PartnershipCode=${partnershipCode}`;
  }

  if (linkCode) {
    url += `&LinkCode=${linkCode}`;
  }

  return instanceApi.get(url);
};
